// extracted by mini-css-extract-plugin
module.exports = {"container":"apps-module--container--2laS0"};